import React from "react"
import SVG from "react-inlinesvg";
import {NavLink}  from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux"
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import { permissionCssClass, ucFirst } from "../../../../../../../util/Helpers";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";

const ProfileDetail = props => {

    const adminUser = useSelector( ({auth}) => (auth.user), shallowEqual);
    const profileData = useSelector(({selectedUser}) => selectedUser.data.profile, shallowEqual);

    // {/* <!--begin::Row--> */}
    return <div>
                <div className="row">
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Basic Details</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=1`}
                                            title="Edit Basic Details"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Username</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {profileData.basic.username}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">First Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {ucFirst(profileData.basic.firstName)}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Last Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {ucFirst(profileData.basic.lastName)}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Middle Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {ucFirst(profileData.basic.middleName)}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Email</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {profileData.basic.email}</span>
                                    </div>
                                    
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">{`${profileData.identificationData?.type?.toUpperCase() ?? ""}`}</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {profileData.identificationData?.value ? `******${profileData.identificationData?.value?.substr(-5)}` : ""}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                     {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">KYC Level</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {profileData.kycLevel}</span>
                                    </div>
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}

                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Employment Details</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=3`}
                                            title="Edit Employment Details"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Employment status </span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.status}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    <div className={profileData.employmentData?.status === "EMPLOYED" || profileData.employmentData?.status === "SELF_EMPLOYED" ? "" : "d-none"}>
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Employer company name </span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.company}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Type of employment</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.type}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Position at employment company</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.position}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Company Address</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.address}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Zip / Postcode</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.zip}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">City</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.city}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">State / Province</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.state}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Country</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.employmentData?.country}</span>
                                        </div>
                                        {/* <!--end::Field--> */}
                                    </div>    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Trust Person</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=2`}
                                            title="Edit Trust Person"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">First Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.trustInfo?.firstName}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Last Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.trustInfo?.lastName}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Email</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.trustInfo?.email}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Phone</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.trustInfo?.phone}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    </div>
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Personal Data</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=2`}
                                            title="Edit Perdonal Data"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Gender</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.personalData?.gender}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Marital Status</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.personalData?.marital}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Mother's Maiden Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.personalData?.mothersMaidenName}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Date of Birth</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.personalData?.birthDay ? [profileData.personalData.birthDay, profileData.personalData.birthMonth, profileData.personalData.birthYear].join("/"): ""}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Politically exposed person</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.personalData?.politicallyExposedNames}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}

                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Address Details</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=2`}
                                            title="Edit Address Details"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Address Line 1</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.street1}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Address Line 1</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.street2}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Postcode</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.postalCode}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">City</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.city}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">State / Province</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.province}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Country</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.addressData?.country}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Next of Kin</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=2`}
                                            title="Edit Next of Kin"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">First Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.nextOfKin?.firstName}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Last Name</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.nextOfKin?.lastName}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Email</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.nextOfKin?.email}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Phone</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.nextOfKin?.phone}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Relationship</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.trustData?.nextOfKin?.relationship}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    </div>
                </div>
                {/* <!--end::Row--> */}
            </div>

}

export default ProfileDetail;
